module.exports = __webpack_public_path__ + "img/vsSeriesBadge.60ece61c.png";